/**
 * Curated list of Indonesian Cities & Regencies (Kota & Kabupaten)
 * for search suggestion and auto-complete in profile forms.
 */
export interface CityOption {
  name: string;
  type: 'Kota' | 'Kabupaten';
  province: string;
}

export const INDONESIAN_CITIES: CityOption[] = [
  // DKI Jakarta
  { name: 'Jakarta Pusat', type: 'Kota', province: 'DKI Jakarta' },
  { name: 'Jakarta Selatan', type: 'Kota', province: 'DKI Jakarta' },
  { name: 'Jakarta Barat', type: 'Kota', province: 'DKI Jakarta' },
  { name: 'Jakarta Timur', type: 'Kota', province: 'DKI Jakarta' },
  { name: 'Jakarta Utara', type: 'Kota', province: 'DKI Jakarta' },
  { name: 'Kepulauan Seribu', type: 'Kabupaten', province: 'DKI Jakarta' },

  // Jawa Barat
  { name: 'Bandung', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Bandung Barat', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Bandung', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Bekasi', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Bekasi', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Bogor', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Bogor', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Cimahi', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Cirebon', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Cirebon', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Depok', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Sukabumi', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Sukabumi', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Tasikmalaya', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Tasikmalaya', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Banjar', type: 'Kota', province: 'Jawa Barat' },
  { name: 'Ciamis', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Cianjur', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Garut', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Indramayu', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Karawang', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Kuningan', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Majalengka', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Pangandaran', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Purwakarta', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Subang', type: 'Kabupaten', province: 'Jawa Barat' },
  { name: 'Sumedang', type: 'Kabupaten', province: 'Jawa Barat' },

  // Banten
  { name: 'Tangerang', type: 'Kota', province: 'Banten' },
  { name: 'Tangerang Selatan', type: 'Kota', province: 'Banten' },
  { name: 'Tangerang', type: 'Kabupaten', province: 'Banten' },
  { name: 'Serang', type: 'Kota', province: 'Banten' },
  { name: 'Serang', type: 'Kabupaten', province: 'Banten' },
  { name: 'Cilegon', type: 'Kota', province: 'Banten' },
  { name: 'Lebak', type: 'Kabupaten', province: 'Banten' },
  { name: 'Pandeglang', type: 'Kabupaten', province: 'Banten' },

  // Jawa Tengah
  { name: 'Semarang', type: 'Kota', province: 'Jawa Tengah' },
  { name: 'Semarang', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Surakarta (Solo)', type: 'Kota', province: 'Jawa Tengah' },
  { name: 'Magelang', type: 'Kota', province: 'Jawa Tengah' },
  { name: 'Magelang', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Pekalongan', type: 'Kota', province: 'Jawa Tengah' },
  { name: 'Pekalongan', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Salatiga', type: 'Kota', province: 'Jawa Tengah' },
  { name: 'Tegal', type: 'Kota', province: 'Jawa Tengah' },
  { name: 'Tegal', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Banyumas (Purwokerto)', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Batang', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Blora', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Boyolali', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Brebes', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Cilacap', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Demak', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Grobogan', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Jepara', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Karanganyar', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Kebumen', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Kendal', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Klaten', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Kudus', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Pati', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Pemalang', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Purbalingga', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Purworejo', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Rembang', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Sragen', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Sukoharjo', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Temanggung', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Wonogiri', type: 'Kabupaten', province: 'Jawa Tengah' },
  { name: 'Wonosobo', type: 'Kabupaten', province: 'Jawa Tengah' },

  // DI Yogyakarta
  { name: 'Yogyakarta', type: 'Kota', province: 'DI Yogyakarta' },
  { name: 'Bantul', type: 'Kabupaten', province: 'DI Yogyakarta' },
  { name: 'Gunungkidul', type: 'Kabupaten', province: 'DI Yogyakarta' },
  { name: 'Kulon Progo', type: 'Kabupaten', province: 'DI Yogyakarta' },
  { name: 'Sleman', type: 'Kabupaten', province: 'DI Yogyakarta' },

  // Jawa Timur
  { name: 'Surabaya', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Malang', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Malang', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Batu', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Blitar', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Blitar', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Kediri', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Kediri', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Madiun', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Madiun', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Mojokerto', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Mojokerto', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Pasuruan', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Pasuruan', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Probolinggo', type: 'Kota', province: 'Jawa Timur' },
  { name: 'Probolinggo', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Banyuwangi', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Bojonegoro', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Bondowoso', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Gresik', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Jember', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Jombang', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Lamongan', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Lumajang', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Magetan', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Nganjuk', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Ngawi', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Pacitan', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Pamekasan', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Ponorogo', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Sampang', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Sidoarjo', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Situbondo', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Sumenep', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Trenggalek', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Tuban', type: 'Kabupaten', province: 'Jawa Timur' },
  { name: 'Tulungagung', type: 'Kabupaten', province: 'Jawa Timur' },

  // Sumatera Utara
  { name: 'Medan', type: 'Kota', province: 'Sumatera Utara' },
  { name: 'Binjai', type: 'Kota', province: 'Sumatera Utara' },
  { name: 'Pematangsiantar', type: 'Kota', province: 'Sumatera Utara' },
  { name: 'Deli Serdang', type: 'Kabupaten', province: 'Sumatera Utara' },
  { name: 'Asahan', type: 'Kabupaten', province: 'Sumatera Utara' },
  { name: 'Karo', type: 'Kabupaten', province: 'Sumatera Utara' },
  { name: 'Simalungun', type: 'Kabupaten', province: 'Sumatera Utara' },

  // Sumatera Barat
  { name: 'Padang', type: 'Kota', province: 'Sumatera Barat' },
  { name: 'Bukittinggi', type: 'Kota', province: 'Sumatera Barat' },
  { name: 'Payakumbuh', type: 'Kota', province: 'Sumatera Barat' },
  { name: 'Pariaman', type: 'Kota', province: 'Sumatera Barat' },
  { name: 'Agam', type: 'Kabupaten', province: 'Sumatera Barat' },
  { name: 'Tanah Datar', type: 'Kabupaten', province: 'Sumatera Barat' },

  // Riau & Kep. Riau
  { name: 'Pekanbaru', type: 'Kota', province: 'Riau' },
  { name: 'Dumai', type: 'Kota', province: 'Riau' },
  { name: 'Batam', type: 'Kota', province: 'Kepulauan Riau' },
  { name: 'Tanjungpinang', type: 'Kota', province: 'Kepulauan Riau' },
  { name: 'Kampar', type: 'Kabupaten', province: 'Riau' },
  { name: 'Bengkalis', type: 'Kabupaten', province: 'Riau' },

  // Sumatera Selatan & Lampung
  { name: 'Palembang', type: 'Kota', province: 'Sumatera Selatan' },
  { name: 'Lubuklinggau', type: 'Kota', province: 'Sumatera Selatan' },
  { name: 'Prabumulih', type: 'Kota', province: 'Sumatera Selatan' },
  { name: 'Ogan Komering Ilir', type: 'Kabupaten', province: 'Sumatera Selatan' },
  { name: 'Bandar Lampung', type: 'Kota', province: 'Lampung' },
  { name: 'Metro', type: 'Kota', province: 'Lampung' },
  { name: 'Lampung Selatan', type: 'Kabupaten', province: 'Lampung' },
  { name: 'Lampung Tengah', type: 'Kabupaten', province: 'Lampung' },

  // Kalimantan
  { name: 'Pontianak', type: 'Kota', province: 'Kalimantan Barat' },
  { name: 'Singkawang', type: 'Kota', province: 'Kalimantan Barat' },
  { name: 'Banjarmasin', type: 'Kota', province: 'Kalimantan Selatan' },
  { name: 'Banjarbaru', type: 'Kota', province: 'Kalimantan Selatan' },
  { name: 'Balikpapan', type: 'Kota', province: 'Kalimantan Timur' },
  { name: 'Samarinda', type: 'Kota', province: 'Kalimantan Timur' },
  { name: 'Bontang', type: 'Kota', province: 'Kalimantan Timur' },
  { name: 'Palangka Raya', type: 'Kota', province: 'Kalimantan Tengah' },
  { name: 'Tarakan', type: 'Kota', province: 'Kalimantan Utara' },

  // Sulawesi
  { name: 'Makassar', type: 'Kota', province: 'Sulawesi Selatan' },
  { name: 'Parepare', type: 'Kota', province: 'Sulawesi Selatan' },
  { name: 'Palopo', type: 'Kota', province: 'Sulawesi Selatan' },
  { name: 'Gowa', type: 'Kabupaten', province: 'Sulawesi Selatan' },
  { name: 'Maros', type: 'Kabupaten', province: 'Sulawesi Selatan' },
  { name: 'Manado', type: 'Kota', province: 'Sulawesi Utara' },
  { name: 'Kotamobagu', type: 'Kota', province: 'Sulawesi Utara' },
  { name: 'Palu', type: 'Kota', province: 'Sulawesi Tengah' },
  { name: 'Kendari', type: 'Kota', province: 'Sulawesi Tenggara' },
  { name: 'Gorontalo', type: 'Kota', province: 'Gorontalo' },

  // Bali & Nusa Tenggara
  { name: 'Denpasar', type: 'Kota', province: 'Bali' },
  { name: 'Badung', type: 'Kabupaten', province: 'Bali' },
  { name: 'Gianyar', type: 'Kabupaten', province: 'Bali' },
  { name: 'Mataram', type: 'Kota', province: 'Nusa Tenggara Barat' },
  { name: 'Bima', type: 'Kota', province: 'Nusa Tenggara Barat' },
  { name: 'Lombok Barat', type: 'Kabupaten', province: 'Nusa Tenggara Barat' },
  { name: 'Kupang', type: 'Kota', province: 'Nusa Tenggara Timur' },

  // Maluku & Papua
  { name: 'Ambon', type: 'Kota', province: 'Maluku' },
  { name: 'Ternate', type: 'Kota', province: 'Maluku Utara' },
  { name: 'Jayapura', type: 'Kota', province: 'Papua' },
  { name: 'Sorong', type: 'Kota', province: 'Papua Barat Daya' },
];

/**
 * Filter city suggestions based on search query.
 */
export function searchIndonesianCities(query: string, maxResults = 8): CityOption[] {
  const clean = query.trim().toLowerCase();
  if (!clean) return INDONESIAN_CITIES.slice(0, maxResults);

  return INDONESIAN_CITIES.filter(
    item =>
      item.name.toLowerCase().includes(clean) ||
      item.province.toLowerCase().includes(clean) ||
      `${item.type} ${item.name}`.toLowerCase().includes(clean)
  ).slice(0, maxResults);
}
